import {LocaleItemContext} from '@packages/shared/constants/Render';
import {AUTO_REDIRECT_OPT_OUT_PARAM} from '@packages/systems/localization-constants';

export function legacyConstructUrlForHreflang({
  domain,
  hrefPrefixForHreflangLinks,
  hrefPrefixSameAsCanonicalUrl,
  globalCanonicalTag,
  primaryPageCanonicalUrl,
  locale,
}: {
  domain: string;
  hrefPrefixForHreflangLinks: string | null | undefined;
  hrefPrefixSameAsCanonicalUrl: boolean | null | undefined;
  globalCanonicalTag: string | null | undefined;
  primaryPageCanonicalUrl: string | null | undefined;
  locale: LocaleItemContext;
}) {
  const isUsingPageCanonicalUrl = Boolean(primaryPageCanonicalUrl);
  const globalOrHrefPrefix = hrefPrefixSameAsCanonicalUrl
    ? (globalCanonicalTag ?? '')
    : ((hrefPrefixForHreflangLinks || globalCanonicalTag) ?? '');
  const root =
    primaryPageCanonicalUrl || globalOrHrefPrefix || `https://${domain}`;

  return isUsingPageCanonicalUrl
    ? // We treat whatever the root is as the entire
      // source of truth for the hreflang links as
      // this is what the user has set as the canonical
      // URL for this page.
      root
    : `${root}${locale.pageHref}`.replace(AUTO_REDIRECT_OPT_OUT_PARAM, '');
}
